export default __webpack_public_path__ + "static/media/tickWithCircle.a5756a4e.svg";